<!--
 * @LastEditors: Yx
 * @LastEditTime: 2022-07-20 16:44:03
 * @Description: 
 * @Author: Yx
 * @Date: 2022-07-20 16:43:24
 * @FilePath: \szjzsoft-framework\src\views\financial\index.vue
-->
<template>
    <div class="financial-page">
       <public-tem :mainTabs="false">
        <div slot="topShow" >
          <div class="img-1">
          <span class="txt">财政产品</span>
          </div>
        </div>
        <div slot="mainBody" style="height:800px">
          <div class="box1-3">
              <span class="txt-3"><router-link to="/product-detail/1">项目库管理系统</router-link></span>
              <span class="txt-3"><router-link to="/product-detail/2">中期财政规划系统</router-link></span>
              <span class="txt-3"><router-link to="/product-detail/3">预算编制管理系统</router-link></span>
              <span class="txt-3"><router-link to="/product-detail/4">预算编制调整系统</router-link></span>
              <span class="txt-3"><router-link to="/product-detail/5">预算执行管理系统</router-link></span>
          </div>
          <div class="box1-3">
            <span class="txt-3"><router-link to="/product-detail/6">预算绩效管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/11">资产管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/7">财务管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/13">专项资金管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/15">会计人员网上办事系统</router-link></span>
          </div>
          <div class="box1-3">
            <span class="txt-3"><router-link to="/product-detail/12">基建资金管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/14">人事工资管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/16">三资监管系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/17">银企互联系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/10">财政大数据应用系统</router-link></span>
          </div>
          <div class="box1-4">
            <span class="txt-3"><router-link to="/product-detail/9">一企一情管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/8">政府采购管理系统</router-link></span>
          </div>
        </div>
       </public-tem>
    </div>
</template>

<script>
import publicTem from "@/components/publicTemplate/index";
export default {
  name: "financial",
  components: {
    publicTem
  },
  data() {
    return {
      advList: []
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style scoped>
</style>
